<template>
  <el-main class="main">
    <recommendations />
  </el-main>
</template>

<script>
import recommendations from '../pub/recommendations.vue'
export default {
  name: 'MDrecommendations',
  components: {
    recommendations
  }
}
</script>
